import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-top: ${rem(20)};
    padding: ${rem(20)} 0;
`;

export const Articles = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(40)};
`;

export const Article = styled.div`
    display: flex;
    gap: ${rem(30)};
    flex-direction: column;

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
    }
`;

export const ArticlesImage = styled.img`
    width: ${rem(180)};
    height: ${rem(180)};
    border-radius: ${rem(12)};
    object-fit: cover;
`;

export const ArticlesDetail = styled.div``;

export const ArticlesDetailTitle = styled.h2`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    padding-bottom: ${rem(15)};
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
`;

export const ArticlesDetailDate = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.textBase};
`;

export const ArticlesDetailAnnotation = styled.p`
    line-height: ${rem(24)};
`;

export const EmptyMessage = styled.div`
    text-align: center;
`;
